import { render, staticRenderFns } from "./AbsoluteIcon.vue?vue&type=template&id=767b6eec&"
import script from "./AbsoluteIcon.vue?vue&type=script&lang=js&"
export * from "./AbsoluteIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports